<template>
    <div class="d-flex flex-column w-100 align-items-center">
        
        <div class="d-flex align-items-center w-75 py-3">
            <img alt="UCCLOG" width="3%" class="brand-image elevation-3" :src="Logo" />
            <fecha-component style="padding: 0.2rem 1rem" />
        </div>
        
    
        <formulario-denuncias class="pt-2"/>

    </div>
</template>

<script>

import Logo from "../../assets/img/logos/logo.png";
import fechaComponent from "@/components/common/FechaComponent.vue";
import FormularioDenuncias from "../../components/denuncias/FormularioDenuncias.vue";


export default {
    data() {
        return {
            Logo
        }
    },
    components: {
        fechaComponent,
        FormularioDenuncias
        
    }
}

</script>
